import { IEntity } from './Interfaces';

export interface IEntityState {
    selectedEntity: IEntity;
    entities: Array<any>;
    isEntityDrawerOpen: boolean;
}

export const initialEntityState: IEntityState = {
    selectedEntity: null,
    entities: [],
    isEntityDrawerOpen: false,
};
